export default "<div class=\"row errorMsg\" *ngIf=\"error\">\n  <div class=\"col-12\">\n    {{error}}\n  </div>\n</div>\n"